<div class="profile-container">
    <div class="underlined-container">
        <div class="name-container">{{name}}</div>
        <div class="email-container">{{email}}</div>
    </div>
    <div *ngIf="isAllowedAccountDropdown" class="underlined-container account-select">
        <app-select-menu [control]="selectedAccount" [items]="accountOptions" [searchable]="false" (onApply)="selectAccount()"
                         [selectMode]="SelectMode.SINGLE" [dropDownPosition]="'top'"></app-select-menu>
    </div>
    <div *ngIf="isAllowedManageAccounts" class="underlined-container">
        <div class="manage-accounts-container" (click)="goToManageScreen()">Manage accounts</div>
    </div>
    <div data-testid="side-menu-logout-button" class="log-out-container">
        <div class="log-out-text" (click)="logOut()">Log out</div>
    </div>
</div>
